import { bootTool } from '../../core/boot';
import { mountWordPressChecker } from './ui';

bootTool('[data-kb-tool="wordpress-security-checker"]', mountWordPressChecker);
